import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from '@nuxtjs/composition-api';
import { ref } from 'vue';

interface Props {
  dark?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSearch',
  props: {
    dark: { type: Boolean }
  },
  emits: ["search"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'search'): void;
}), expose: any, slots: any, attrs: any }) {



const router = useRouter();

const searchText = ref('');
const tags = ['#canyon', '#contact', '#keyboard'];
const selectTag = (tag) => {
  searchText.value = tag.slice(1);
};
const search = () => {
  if (!searchText.value) return;
  router.push({
    path: '/search/products/',
    query: { search: searchText.value },
  });
  emit('search');
};

return { __sfc: true,emit, router, searchText, tags, selectTag, search }
}

})